import { Fragment, useContext } from 'react'
import DatePickerSearch from './DatePickerSearch'
import DropDownSearch from './SearchDropDown/DropDownSearch'
import { DomainContext } from '../../../../context/DomainContext'
import { CRRender } from '../../../crRender'
import InputField from '../../../formFields/InputField/Field'

const SEARCH_OBJECT = 1

const SearchTools = ({ children, haveCustomPriority }) => {

    const { searchData, handleSearchData, searchTypes } = useContext(DomainContext)


    return (
        < div className='row'>
            {haveCustomPriority && children}

            <CRRender isRender={searchData}>
                {Object.entries(searchData)?.map(([key, value], index) => (
                    <Fragment key={index}>
                        <InputField lang={'any'} isRequired={false} className={'col-lg-3 col-md-6 col-sm-12'} setValue={val => handleSearchData(key, val)} value={value} id={key} label={key} />
                    </Fragment>
                ))}
            </CRRender>

            <CRRender isRender={searchTypes} >
                {Object.entries(searchTypes)?.map((customeField, index) => (
                    <Fragment key={index}>
                        <CRRender isRender={customeField[SEARCH_OBJECT].type == 'DropDown'} >
                            <Fragment key={`${customeField[SEARCH_OBJECT].Header}_${customeField[SEARCH_OBJECT].Header}_${index}`}>
                                <DropDownSearch
                                    className={"col-lg-3 col-md-6 col-sm-12"}
                                    ApiMethod={customeField[SEARCH_OBJECT]?.apiSource}
                                    isMulti={customeField[SEARCH_OBJECT].isMulti}
                                    isRequired={customeField[SEARCH_OBJECT].isRequired}
                                    accessor={customeField[SEARCH_OBJECT].accessor}
                                    depArr={customeField[SEARCH_OBJECT].depArr}
                                    Header={customeField[SEARCH_OBJECT].Header}
                                    optionList={customeField[SEARCH_OBJECT]?.options}
                                    probName={customeField[SEARCH_OBJECT]?.probName}
                                    sourceId={customeField[SEARCH_OBJECT]?.sourceId}
                                    defaultValue={customeField[SEARCH_OBJECT]?.defaultValue}
                                />
                            </Fragment>
                        </CRRender>

                        <CRRender isRender={customeField[SEARCH_OBJECT].type == 'Date'} >
                            <Fragment key={`${customeField[SEARCH_OBJECT].Header}_${customeField[SEARCH_OBJECT].Header}_${index}`}>
                                <DatePickerSearch
                                    className={"col-lg-3 col-md-3 col-sm-12"}
                                    isMulti={customeField[SEARCH_OBJECT].isMulti}
                                    Header={customeField[SEARCH_OBJECT].Header}
                                    accessor={customeField[SEARCH_OBJECT].accessor}
                                    probName={customeField[SEARCH_OBJECT]?.probName}
                                />
                            </Fragment>
                        </CRRender>
                    </Fragment>))}
            </CRRender>

            {!haveCustomPriority && children}
        </div >
    )
}

export default SearchTools
